import { getResolution, latLngToCell } from "h3-js";

export const REPORT_LOCATION_H3_RESOLUTION = 7;

export function isValidLocationCoordinatePair(coordinates) {
  return Boolean(
    coordinates &&
      typeof coordinates.latitude === "number" &&
      typeof coordinates.longitude === "number" &&
      Number.isFinite(coordinates.latitude) &&
      Number.isFinite(coordinates.longitude) &&
      coordinates.latitude >= -90 &&
      coordinates.latitude <= 90 &&
      coordinates.longitude >= -180 &&
      coordinates.longitude <= 180
  );
}

export function locationH3FromCoordinates(coordinates) {
  if (!isValidLocationCoordinatePair(coordinates)) return null;
  const locationH3 = latLngToCell(
    coordinates.latitude,
    coordinates.longitude,
    REPORT_LOCATION_H3_RESOLUTION
  );
  return getResolution(locationH3) === REPORT_LOCATION_H3_RESOLUTION ? locationH3 : null;
}
